<script lang="ts">
import { h } from 'vue';
import { RouterLink } from 'vue-router';

export default {
  static: {
    title: 'Ошибка 404',
    errorDescription:
      'Вы попали на несуществующую страницу или зашли по неверному адресу.',
    helpText: 'Попробуйте начать с ',
    linkText: 'Главной страницы',
  },
  render(ctx: any) {
    return h(
      'div',
      {
        style: {
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
        },
      },
      [
        h('h2', {}, ctx.$options.static.title),
        h(
          'p',
          {
            style: {
              fontSize: '1.4rem',
            },
          },
          ctx.$options.static.errorDescription
        ),
        h(
          'span',
          {
            style: {
              fontSize: '1.4rem',
            },
          },
          [
            ctx.$options.static.helpText,
            h(
              RouterLink,
              {
                to: '/',
                class: 'link',
              },
              ctx.$options.static.linkText
            ),
          ]
        ),
      ]
    );
  },
};
</script>
